import axios from '@/utils/axios'

export default async function GetFeaturedProducts(country?: string, currency?: string) {
  const params = new URLSearchParams();
  
  if (country) {
    params.append('country', country);
  }
  
  if (currency) {
    params.append('currency', currency);
  }
  
  const queryString = params.toString();
  const url = process.env.NEXT_PUBLIC_API_URL + '/products/get-featured-products' + 
              (queryString ? `?${queryString}` : '');
  
  const { data } = await axios.get(url);
  return data;
}

